import { router } from "@smakecloud/api-client-helper";
import { auth } from "~/lib/api/endpoints/auth";
import { machinery } from "~/lib/api/endpoints/machinery";
import { production } from "~/lib/api/endpoints/production";
import { productionExport } from "~/lib/api/endpoints/productionExport";
import { productionMethods } from "~/lib/api/endpoints/productionMethods";
import { stockItems } from "~/lib/api/endpoints/stockItems";
import { remoteStorages } from "./endpoints/remoteStorages";
import { settings } from "./endpoints/settings";

export const api = router(
    {
        auth,
        machinery,
        production,
        productionExport,
        productionMethods,
        remoteStorages,
        settings,
        stockItems,
    },
    "production-frontend",
);
